import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of, tap } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { LanguageUtils } from '../../utils/language.utils';
import { ILabelsService, LabelResponse } from './labels.interface';

@Injectable({
  providedIn: 'root'
})
export class LabelsService implements ILabelsService {
  cache = new Map<string, LabelResponse>();

  constructor(private httpClient: HttpClient) { }

  getLabels(): Observable<LabelResponse> {
    const cached = this.cache.get(LanguageUtils.getLanguage());
    if (cached) {
      return of(cached);
    } else {
      return this.httpClient.get<LabelResponse>(environment.apiPublicUrl + '/labels?language=' + LanguageUtils.getLanguage()).pipe(
        tap(data => this.cache.set(LanguageUtils.getLanguage(), data))
      );
    }
  }
}
